import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48.777",
  height: "39.407"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "data-name": "Group 8478",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 1902",
    d: "M10.2 39.406a1.128 1.128 0 0 1-.945-.511l-2.187-3.341H3.149A3.11 3.11 0 0 1 0 32.49V13.05a3.106 3.106 0 0 1 3.149-3.055h6.222a1.129 1.129 0 1 1 0 2.257H3.149a.849.849 0 0 0-.891.8V32.49a.852.852 0 0 0 .891.805h4.53a1.126 1.126 0 0 1 .945.512l1.576 2.408 1.576-2.408a1.126 1.126 0 0 1 .945-.512h16.126a.851.851 0 0 0 .888-.805v-2.138a1.129 1.129 0 1 1 2.258 0v2.138a3.109 3.109 0 0 1-3.147 3.064H13.331l-2.187 3.342a1.128 1.128 0 0 1-.945.511"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 1903",
    d: "M45.72.002h-29.7a3.049 3.049 0 0 0-3.062 3.029v18.8a3.049 3.049 0 0 0 3.062 3.03h19.1l2.376 3.741a.942.942 0 0 0 .794.437.943.943 0 0 0 .796-.437l2.37-3.739h4.264a3.049 3.049 0 0 0 3.062-3.029v-18.8A3.049 3.049 0 0 0 45.72.002M21.532 14.518a2.546 2.546 0 1 1 2.546-2.546 2.542 2.542 0 0 1-2.546 2.546m9.334 0a2.546 2.546 0 1 1 2.546-2.546 2.542 2.542 0 0 1-2.546 2.546m9.334 0a2.546 2.546 0 1 1 2.546-2.546 2.542 2.542 0 0 1-2.546 2.546"
  })
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }